module.exports = __webpack_public_path__ + "static/media/yesbitLogo.5d33bab8.png";